/* v8 ignore start */
import posthog from 'posthog-js';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost,
    defaults: runtimeConfig.public.posthogDefaults,
    person_profiles: 'identified_only',
    loaded: (posthog) => {
      posthog.debug(false);
    },
  });

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});

/* v8 ignore stop */
